import {
  SET_USER_SIGNUP_REQUEST,
  SET_USER_SIGNUP_SUCCESS,
  SET_USER_SIGNUP_FAILURE,
  GET_SIGNUP_LANGS_REQUEST,
  GET_SIGNUP_LANGS_SUCCESS,
  GET_SIGNUP_LANGS_FAILURE,
  SET_USER_SIGNUP_CONFIRM_CODE_REQUEST,
  SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS,
  SET_USER_SIGNUP_CONFIRM_CODE_FAILURE,
  SET_USER_SIGNUP_SEND_CODE_REQUEST,
  SET_USER_SIGNUP_SEND_CODE_SUCCESS,
  SET_USER_SIGNUP_SEND_CODE_FAILURE,
  SET_USER_SIGNUP_REGISTRATION_REQUEST,
  SET_USER_SIGNUP_REGISTRATION_SUCCESS,
  SET_USER_SIGNUP_REGISTRATION_FAILURE,
  SET_USER_SIGNUP_REVIEW_HAS_ERROR,
  SET_USER_SIGNUP_STEP_REQUEST,
  SET_USER_SIGNUP_STEP_SUCCESS,
  SET_USER_SIGNUP_STEP_FAILURE,
  SET_VALIDATE_SOCIAL_CHANNEL_REQUEST,
  SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS,
  SET_VALIDATE_SOCIAL_CHANNEL_FAILURE,
  GET_INVITATION_CODE_REQUEST,
  GET_INVITATION_CODE_SUCCESS,
  GET_INVITATION_CODE_FAILURE,
} from "consts/actionTypes";

const initialState = {
  fetching: false,
  userApplicationRequest: null,
  fetchingLanguages: false,
  languages: [],
  signupToken: null,
  hasErrorConfirmCode: null,
  isEmailUsed: false,
  reviewHasError: {
    birthday: null,
    display_name: null,
    first_name: null,
    last_name: null,
    phone: null,
    manager_represented: null,
    manager_name: null,
    manager_email: null,
    social_channels: null,
  },
  rewardsUser: {
    first_name: "",
    last_name: "",
    display_name: "",
    email: "",
    confirm_email: "",
    birthday: "",
    phone: "",
    network: "",
    password: "",
    password_confirmation: "",
    domain_name: "",
    terms: false,
    marketing_opt_in: false,
    sms_opt_in: false,
    country: null,
    language: null,
    heard_about_us: null,
    used_affiliate_before: null,
    marketing_opt_in: false,
    manager_represented: null,
    manager_name: "",
    manager_email: "",
    manager_reach_out: null,
  },
  fetchingManualEntryChannels: false,
  manualEntryChannels: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_SIGNUP_REQUEST:
      return {
        ...state,
        fetching: true,
        userApplicationRequest: null,
      };
    case SET_USER_SIGNUP_SUCCESS:
      return {
        ...state,
        fetching: false,
        userApplicationRequest: action.data,
      };
    case SET_USER_SIGNUP_FAILURE:
      return {
        ...state,
        fetching: false,
        userApplicationRequest: null,
      };
    case SET_USER_SIGNUP_CONFIRM_CODE_REQUEST:
      return {
        ...state,
        fetchingConfirmCode: true,
        hasErrorConfirmCode: null,
      };
    case SET_USER_SIGNUP_CONFIRM_CODE_SUCCESS:
      return {
        ...state,
        fetchingConfirmCode: false,
        signupToken: action.data,
      };
    case SET_USER_SIGNUP_CONFIRM_CODE_FAILURE:
      return {
        ...state,
        hasErrorConfirmCode: action.hasErrorConfirmCode,
      };

    case SET_USER_SIGNUP_SEND_CODE_REQUEST:
      return {
        ...state,
        isEmailUsed: false,
      };
    case SET_USER_SIGNUP_SEND_CODE_SUCCESS:
      return {
        ...state,
        isEmailUsed: action.isEmailUsed,
      };
    case SET_VALIDATE_SOCIAL_CHANNEL_REQUEST:
      return {
        ...state,
        fetchingManualEntryChannels: true,
        manualEntryChannels: [],
      };
    case SET_VALIDATE_SOCIAL_CHANNEL_SUCCESS:
      return {
        ...state,
        fetchingManualEntryChannels: false,
        manualEntryChannels: action.data,
      };
    case SET_VALIDATE_SOCIAL_CHANNEL_FAILURE:
      return {
        ...state,
        fetchingManualEntryChannels: false,
        manualEntryChannels: [],
      };
    case SET_USER_SIGNUP_REVIEW_HAS_ERROR:
      return {
        ...state,
        reviewHasError: { ...state.reviewHasError, ...action.data },
      };
    case SET_USER_SIGNUP_REGISTRATION_REQUEST:
      return {
        ...state,
        fetchingUserRegistration: true,
      };
    case SET_USER_SIGNUP_REGISTRATION_SUCCESS:
      return {
        ...state,
        fetchingUserRegistration: false,
        rewardsUser: action.data,
      };
    case SET_USER_SIGNUP_REGISTRATION_FAILURE:
      return {
        ...state,
        fetchingUserRegistration: false,
        rewardsUser: initialState.rewardsUser,
      };
    case SET_USER_SIGNUP_STEP_SUCCESS:
      return {
        ...state,
        rewardsUser: action.data,
      };
    case GET_SIGNUP_LANGS_REQUEST:
      return {
        ...state,
        fetchingLanguages: true,
        languages: null,
      };
    case GET_SIGNUP_LANGS_SUCCESS:
      return {
        ...state,
        fetchingLanguages: false,
        languages: action.data,
      };
    case GET_SIGNUP_LANGS_FAILURE:
      return {
        ...state,
        fetchingLanguages: false,
        languages: null,
      };
    case GET_INVITATION_CODE_REQUEST:
      return {
        ...state,
        fetchingInvitationCode: true,
        rewardsUserInvitation: null,
      };
    case GET_INVITATION_CODE_SUCCESS:
      return {
        ...state,
        fetchingInvitationCode: false,
        rewardsUserInvitation: action.data,
      };
    case GET_INVITATION_CODE_FAILURE:
      return {
        ...state,
        fetchingInvitationCode: false,
        rewardsUserInvitation: action.err,
      };
    default:
      return state;
  }
};
